import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import { StyledDiv, StyledLabel, StyledInput } from './CardSelect.styles';

const CardSelect = forwardRef(({ children, className, id, name, testId, value, onClick, onChange, onBlur, disabled, title }, ref) => (
  <StyledDiv data-cy={`${testId}-select-container`} data-testid={`${testId}-select-container`} className={className}>
    <StyledInput
      type="radio"
      name={name}
      value={value}
      id={id}
      ref={ref}
      onClick={onClick}
      onChange={onChange}
      onBlur={onBlur}
      data-testid={`${testId}-input`}
      disabled={disabled}
    />
    <StyledLabel htmlFor={id} title={title}>
      {children}
    </StyledLabel>
  </StyledDiv>
));

CardSelect.displayName = 'CardSelect';

CardSelect.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  testId: PropTypes.string,
  value: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  title: PropTypes.string
};

export default CardSelect;
